import React, { useState, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Page from '../layout/Page';
import { Paper } from '@mui/material';
import RoleContext from '../auth/RoleContext.js';
import ListViewCommandBar from '../commandBar/ListViewCommandBar.js';
import ListAuthApprovalTypes from './ListAuthApprovalTypes.js';
import ListAuthApprovalCategories from './ListAuthApprovalCategories.js'; // <-- ADD
import { default as bus } from '../utils/EventBus';
import TabPanel from '../form/TabPanel'; // <-- your tab panel path

export default function ManageAuthApprovalsPage(props = {}) {
  const roleDetails = useContext(RoleContext);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [listRefreshKey, setListRefreshKey] = useState(new Date().toISOString());
  const [showFilters, setShowFilters] = useState(false);

  const startLoading = () => setIsLoading(true);
  const stopLoading = () => setIsLoading(false);
  const toggleFilters = () => setShowFilters(!showFilters);

  const addRecord = () => {
    bus.emit('add-approval-type-or-category');
  };

  const breadcrumb = (
    <span>
      <span onClick={(e) => navigate('/app/admin')}>
        <a href="#">Application Administration</a>
      </span>{' '}
      {'>'} Manage Authorization Types & Categories
    </span>
  );

  // Tab definitions
  const tabs = [
    {
      key: 'types',
      label: 'Approval Types',
      el: (
        <Paper sx={{ margin: '0 auto 1em auto' }}>
          <ListAuthApprovalTypes
            key={listRefreshKey}
            showFilters={showFilters}
            startLoading={startLoading}
            stopLoading={stopLoading}
            searchFilter={{ isActive: false }}
            refresh={() => setListRefreshKey(new Date().toISOString())}
          />
        </Paper>
      ),
    },
    {
      key: 'categories',
      label: 'Approval Categories',
      el: (
        <Paper sx={{ margin: '0 auto 1em auto' }}>
          <ListAuthApprovalCategories
            key={`${listRefreshKey}-categories`}
            showFilters={showFilters}
            startLoading={startLoading}
            stopLoading={stopLoading}
            searchFilter={{ isActive: false }}
            refresh={() => setListRefreshKey(new Date().toISOString())}
          />
        </Paper>
      ),
    },
  ];

  return (
    <Page
      {...props}
      breadcrumb={breadcrumb}
      isLoading={isLoading}
      commandBar={
        <ListViewCommandBar
          showFilters={true}
          toggleFilters={toggleFilters}
          addRecord={addRecord}
          showAdd={true}
        />
      }
    >
      <TabPanel
        panelId="auth-approvals"
        tabs={tabs}
        defaultTab={0}
        fullWidth
      />
    </Page>
  );
}